module.exports = __webpack_public_path__ + "img/Yostar_Alibaba_Logo@3x.ec6511a0.png";